import {
	SET_JD_PHOTOS_ADD_DATA,
	SET_SELECTED_GALLERY_IMAGES,
	TOGGLE_GALLERY_MODAL,
	TOGGLE_PHOTO_SLIDER
} from './types'

export const setSelectedGalleryImages = (payload) => ({
	type: SET_SELECTED_GALLERY_IMAGES,
	payload
})

export const toggleGalleryModal = (payload) => ({
	type: TOGGLE_GALLERY_MODAL,
	payload
})
export const togglePhotoSlider = (payload) => ({
	type: TOGGLE_PHOTO_SLIDER,
	payload
})

export const setJdPhotosData = (payload) => ({
	type: SET_JD_PHOTOS_ADD_DATA,
	payload
})
